<template>
  <div class="min-h-screen bg-[#F0F0F0] p-4 sm:p-6 md:p-8 font-sans selection:bg-[#20FCF1]/30">
    <div class="max-w-7xl mx-auto pb-24">
      
      <!-- Command Header -->
      <div class="flex flex-col md:flex-row md:items-center justify-between mb-12 gap-6 relative pb-6">
        <div>
          <h1 class="text-3xl md:text-4xl font-black text-slate-900 uppercase tracking-tight leading-none flex items-center gap-4">
            <svg class="w-10 h-10 text-[#20FCF1] fill-[#20FCF1]/10" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <path d="M9 12l2 2 4-4"></path>
            </svg>
            Onboarding Material
          </h1>
          <p class="text-[#20FCF1] font-black uppercase text-[10px] tracking-[0.2em] mt-4 ml-14">
            Mandatory Compliance Registry • Sentinel Safe Premium
          </p>
        </div>
      </div>

      <!-- Material Index Grid -->
      <div class="grid grid-cols-1 gap-16">
        
        <!-- Module 1: Code of Conduct -->
        <section id="code-of-conduct" class="bg-white border border-slate-100 rounded-[40px] overflow-hidden shadow-2xl transition-all duration-500 hover:shadow-[#20FCF1]/10 group">
          <div class="p-8 border-b border-slate-50 flex items-center justify-between bg-slate-50/50">
            <h2 class="text-xl font-black text-slate-900 uppercase tracking-tight flex items-center gap-3">
              <span class="w-2.5 h-2.5 bg-[#20FCF1] rounded-full group-hover:animate-pulse"></span>
              1. Code of Conduct
            </h2>
            <span class="text-[9px] font-black uppercase tracking-widest text-slate-400 bg-white px-4 py-1.5 rounded-full border border-slate-100 shadow-sm">Policy ID: 408123</span>
          </div>
          <div class="p-4 sm:p-8">
            <div class="relative w-full aspect-video rounded-[32px] overflow-hidden bg-slate-100 border border-slate-200 shadow-inner min-h-[400px] md:min-h-[600px]">
              <iframe
                src="https://designrr.page/?id=408123&token=935559749&type=FP&h=2716"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                class="absolute inset-0 w-full h-full"
                title="Code of Conduct"
              ></iframe>
            </div>
          </div>
        </section>

        <!-- Module 2: Corporate Policies -->
        <section id="tecs-policies" class="bg-white border border-slate-100 rounded-[40px] overflow-hidden shadow-2xl transition-all duration-500 hover:shadow-[#20FCF1]/10 group">
          <div class="p-8 border-b border-slate-50 flex items-center justify-between bg-slate-50/50">
            <h2 class="text-xl font-black text-slate-900 uppercase tracking-tight flex items-center gap-3">
              <span class="w-2.5 h-2.5 bg-[#22C55E] rounded-full group-hover:animate-pulse"></span>
              2. Corporate Policies
            </h2>
            <span class="text-[9px] font-black uppercase tracking-widest text-slate-400 bg-white px-4 py-1.5 rounded-full border border-slate-100 shadow-sm">Policy ID: 408129</span>
          </div>
          <div class="p-4 sm:p-8">
            <div class="relative w-full aspect-video rounded-[32px] overflow-hidden bg-slate-100 border border-slate-200 shadow-inner min-h-[400px] md:min-h-[600px]">
              <iframe
                src="https://designrr.page/?id=408129&token=4146276002&type=FP&h=3332"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                class="absolute inset-0 w-full h-full"
                title="TECS Policies"
              ></iframe>
            </div>
          </div>
        </section>

        <!-- Module 3: System Procedures -->
        <section id="tecs-procedures" class="bg-white border border-slate-100 rounded-[40px] overflow-hidden shadow-2xl transition-all duration-500 hover:shadow-[#20FCF1]/10 group">
          <div class="p-8 border-b border-slate-50 flex items-center justify-between bg-slate-50/50">
            <h2 class="text-xl font-black text-slate-900 uppercase tracking-tight flex items-center gap-3">
              <span class="w-2.5 h-2.5 bg-[#3B82F6] rounded-full group-hover:animate-pulse"></span>
              3. System Procedures
            </h2>
            <span class="text-[9px] font-black uppercase tracking-widest text-slate-400 bg-white px-4 py-1.5 rounded-full border border-slate-100 shadow-sm">Policy ID: 409669</span>
          </div>
          <div class="p-4 sm:p-8">
            <div class="relative w-full aspect-video rounded-[32px] overflow-hidden bg-slate-100 border border-slate-200 shadow-inner min-h-[400px] md:min-h-[600px]">
              <iframe
                src="https://designrr.page/?id=409669&token=1849493302&type=FP&h=2170"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                class="absolute inset-0 w-full h-full"
                title="TECS Procedures"
              ></iframe>
            </div>
          </div>
        </section>

        <!-- Module 4: Primary Sponsor Contract -->
        <section id="sponsor-contract" class="bg-white border border-slate-100 rounded-[40px] overflow-hidden shadow-2xl transition-all duration-500 hover:shadow-[#20FCF1]/10 group">
          <div class="p-8 border-b border-slate-50 flex items-center justify-between bg-slate-50/50">
            <h2 class="text-xl font-black text-slate-900 uppercase tracking-tight flex items-center gap-3">
              <span class="w-2.5 h-2.5 bg-[#F97316] rounded-full group-hover:animate-pulse"></span>
              4. Primary Sponsor Contract
            </h2>
            <span class="text-[9px] font-black uppercase tracking-widest text-slate-400 bg-white px-4 py-1.5 rounded-full border border-slate-100 shadow-sm">Policy ID: 400375</span>
          </div>
          <div class="p-4 sm:p-8">
            <div class="relative w-full aspect-video rounded-[32px] overflow-hidden bg-slate-100 border border-slate-200 shadow-inner min-h-[400px] md:min-h-[600px]">
              <iframe
                src="https://designrr.page/?id=400375&token=582179900&type=FP&h=3068"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                class="absolute inset-0 w-full h-full"
                title="Sponsor Contract"
              ></iframe>
            </div>
          </div>
        </section>

      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

onMounted(() => {
  const hash = route.hash;
  if (hash) {
    // 🛡️ REINFORCED STABILITY DELAY
    // Increased timeout for mobile browsers to allow the white background to render
    // before executing the scroll-to-module command.
    setTimeout(() => {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 500);
  }
});
</script>

<style scoped>
/* 🛡️ IOS SAFARI OPTIMISATION */
/* These styles help the browser manage iframes without memory panics */
iframe {
  border: none;
  background-color: white;
  display: block;
}

:deep(.aspect-video) {
  position: relative;
  width: 100%;
}

/* Ensure smooth scrolling for mobile jump-links */
html {
  scroll-behavior: smooth;
}
</style>